import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';

const MobileConsentSolutionNameField = ({ record, basePath }) => {
  const { description, id, name } = record;
  const encodedURI = encodeURIComponent(id);
  return (
    <Tooltip title={description} aria-label={description}>
      <Link to={{ pathname: `${basePath}/${encodedURI}` }}>
        {name}
      </Link>
    </Tooltip>
  );
};

export default MobileConsentSolutionNameField;
